import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
// import 'assets/fonts/SF Pro Rounded Bold/SF Pro Rounded Bold/SF-Pro-Rounded-Bold.otf'; 
import App from './App';


ReactDOM.render(

    <App />
  ,
  document.getElementById('root')
);


